import { createRetrievalBasicInformation } from "./createRetrievalBasicInformation";

export default createRetrievalBasicInformation("guardianship");
